import React, {createContext, PropsWithChildren} from 'react';

import {LoadingView} from '../../components/loading/loading';
import {AppContext} from '../../types/state.types';

export type AppContextValue = Omit<AppContext, 'history'>

export const AppContextContext = createContext<AppContextValue>(null as any);

type Props = PropsWithChildren<{
    context: AppContextValue
}>

export const AppContextProvider = ({ children, context }: Props) => {
    return <AppContextContext.Provider value={context}>
        {context === null ? <LoadingView/> : children}
    </AppContextContext.Provider>;
};
